import { ResponsivePie } from "@nivo/pie";
import { tokens } from "../theme";
import { Box, Typography, useTheme } from "@mui/material";
import { mockDataProjects as data } from "../data/mockProjectData";

const PieChart = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    //capex-opex
    var capex = 0;
    var opex = 0;
    var floating = 0;

    //status
    var cold = 0;
    var extreme = 0;
    var loa = 0;
    var lost = 0;
    var newlead = 0;
    var warm = 0;

    //type_of_project
    var fl = 0;
    var gm = 0;
    var rt = 0;



    data.forEach(myFun);

    function myFun(item, index) {
        //capex-opex
        if (item.capex_opex === "OPEX") {
            opex += 1;
        }
        if (item.capex_opex === "CAPEX") {
            capex += 1;
        } if (item.capex_opex === "FLOATING") {
            floating += 1;
        }

        //status
        if (item.status === "Cold") {
            cold += 1;
        }
        if (item.status === "Extreme") {
            extreme += 1;
        } if (item.status === "LOA") {
            loa += 1;
        } if (item.status === "New Lead") {
            newlead += 1;
        } if (item.status === "Warm") {
            warm += 1;
        } if (item.status === "Lost") {
            lost += 1;
        }

        //type_of_project

        if (item.type_of_project === "FL") {
            fl += 1;
        }
        if (item.type_of_project === "GM") {
            gm += 1;
        } if (item.type_of_project === "RT") {
            rt += 1;
        }


    }

    //data for capex and opex pie charts





    const capex_opex = [
        { id: 'CAPEX', name: 'CAPEX', value: capex, },
        { id: 'OPEX', name: 'OPEX', value: opex, },
        { id: 'FLOATING', name: 'FLOATING', value: floating, }];
    const capex_opex_colors = ["#5b9bd5", "#43682b", "#ffc000"]
    // console.log(capex+"---"+opex+"---"+floating);

    //data for status piechart    
    const status = [
        { id: "Cold", lable: 'Cold', value: cold, },
        { id: "Extreme", lable: 'Extreme', value: extreme, },
        { id: "LOA", lable: 'LOA', value: loa, },
        { id: "Lost", lable: 'Lost', value: lost, },
        { id: "New Lead", lable: 'New Lead', value: newlead, },
        { id: "Warm", lable: 'Warm', value: warm, }];
    const status_colors = ['#4472c4', '#ed7d31', '#a5a5a5', '#ffc000', '#5b9bd5', '#70ad47']


    //data for "type of project pie charts"
    const type_of_project = [
        { id: 'GM', name: 'GM', value: gm },
        { id: 'FL', name: 'FL', value: fl },
        { id: 'RT', name: 'RT', value: rt }];
    const top_colors = ["#2e75b6", "#92d050", "#ffc000"]


    return (
        <Box display="flex" alignItems="flex-start" justifyContent="space-around" sx={{ height: "100%", width: "100%" }} >
            <Box display="flex" flexDirection="column" alignItems="flex-end" justifyContent="flex-start" sx={{ height: "75vh", width: "50%", border: `1px solid ${colors.grey[100]}` }}>
                <Typography variant="h4" marginRight="20px">
                    Status
                </Typography>
                <ResponsivePie
                    data={status}
                    colors={status_colors}
                    theme={{
                        axis: {
                            domain: {
                                line: {
                                    stroke: colors.grey[100],
                                },
                            },
                            legend: {
                                text: {
                                    fill: colors.grey[100],
                                },
                            },
                            ticks: {
                                line: {
                                    stroke: colors.grey[100],
                                    strokeWidth: 1,
                                },
                                text: {
                                    fill: colors.grey[100],
                                },
                            },
                        },
                        legends: {
                            text: {
                                fill: colors.grey[100],
                            },
                        },
                        tooltip: {
                            container: {
                                background: "#ffffff",
                                color: "black",
                                fontSize: 11,
                            },
                        }
                    }}
                    margin={{ top: 40, right: 80, bottom: 80, left: 100 }}
                    activeOuterRadiusOffset={8}
                    borderColor={{
                        from: "color",
                        modifiers: [["darker", 0.2]],
                    }}
                    arcLinkLabelsSkipAngle={10}
                    arcLinkLabelsTextColor={colors.grey[100]}
                    arcLinkLabelsThickness={2}
                    arcLinkLabelsColor={{ from: "color" }}
                    enableArcLabels={false}
                    arcLabelsRadiusOffset={0.4}
                    arcLabelsSkipAngle={7}
                    arcLabelsTextColor={{
                        from: "color",
                        modifiers: [["darker", 2]],
                    }}
                    defs={[
                        {
                            id: "dots",
                            type: "patternDots",
                            background: "inherit",
                            color: "rgba(255, 255, 255, 0.3)",
                            size: 4,
                            padding: 1,
                            stagger: true,
                        },
                        {
                            id: "lines",
                            type: "patternLines",
                            background: "inherit",
                            color: "rgba(255, 255, 255, 0.3)",
                            rotation: -45,
                            lineWidth: 6,
                            spacing: 10,
                        },
                    ]}
                    legends={[
                        {
                            anchor: "bottom",
                            direction: "row",
                            justify: false,
                            translateX: 0,
                            translateY: 56,
                            itemsSpacing: 0,
                            itemWidth: 80,
                            itemHeight: 18,
                            itemTextColor: "#999",
                            itemDirection: "left-to-right",
                            itemOpacity: 1,
                            symbolSize: 15,
                            symbolShape: "square",
                            effects: [
                                {
                                    on: "hover",
                                    style: {
                                        itemTextColor: colors.grey[100],
                                    },
                                },
                            ],
                        },
                    ]}
                />
            </Box>
            <Box
                display="flex" flexDirection="column" alignItems="flex-start" justifyContent="flex-start"
                sx={{ height: "50%", width: "50%", }}>


                <Box
                    display="flex" flexDirection="column" alignItems="flex-end" justifyContent="center"
                    sx={{ padding: "10px", width: "100%", height: "100%", border: `1px solid ${colors.grey[100]}` }}>
                    <Typography variant="h4" marginRight="20px">
                        CAPEX/OPEX
                    </Typography>
                    <ResponsivePie
                        data={capex_opex}
                        colors={capex_opex_colors}
                        theme={{
                            axis: {
                                domain: {
                                    line: {
                                        stroke: colors.grey[100],
                                    },
                                },
                                legend: {
                                    text: {
                                        fill: colors.grey[100],
                                    },
                                },
                                ticks: {
                                    line: {
                                        stroke: colors.grey[100],
                                        strokeWidth: 1,
                                    },
                                    text: {
                                        fill: colors.grey[100],
                                    },
                                },
                            },
                            legends: {
                                text: {
                                    fill: colors.grey[100],
                                },
                            },
                            tooltip: {
                                container: {
                                    background: "#ffffff",
                                    color: "black",
                                    fontSize: 11,
                                },
                            }
                        }}
                        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                        activeOuterRadiusOffset={8}
                        borderColor={{
                            from: "color",
                            modifiers: [["darker", 0.2]],
                        }}
                        arcLinkLabelsSkipAngle={10}
                        arcLinkLabelsTextColor={colors.grey[100]}
                        arcLinkLabelsThickness={2}
                        arcLinkLabelsColor={{ from: "color" }}
                        enableArcLabels={false}
                        arcLabelsRadiusOffset={0.4}
                        arcLabelsSkipAngle={7}
                        arcLabelsTextColor={{
                            from: "color",
                            modifiers: [["darker", 2]],
                        }}
                        defs={[
                            {
                                id: "dots",
                                type: "patternDots",
                                background: "inherit",
                                color: "rgba(255, 255, 255, 0.3)",
                                size: 4,
                                padding: 1,
                                stagger: true,
                            },
                            {
                                id: "lines",
                                type: "patternLines",
                                background: "inherit",
                                color: "rgba(255, 255, 255, 0.3)",
                                rotation: -45,
                                lineWidth: 6,
                                spacing: 10,
                            },
                        ]}
                        legends={[
                            {
                                anchor: "bottom",
                                direction: "row",
                                justify: false,
                                translateX: 0,
                                translateY: 56,
                                itemsSpacing: 0,
                                itemWidth: 100,
                                itemHeight: 18,
                                itemTextColor: "#999",
                                itemDirection: "left-to-right",
                                itemOpacity: 1,
                                symbolSize: 18,
                                symbolShape: "circle",
                                effects: [
                                    {
                                        on: "hover",
                                        style: {
                                            itemTextColor: colors.grey[100],
                                        },
                                    },
                                ],
                            },
                        ]}
                    />

                </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-end"
                    justifyContent="center"
                    sx={{
                        padding: "10px",
                        width: "100%",
                        height: "100%",
                        border: `1px solid ${colors.grey[100]}`
                    }}>
                    <Typography variant="h4" marginRight="20px">Type Of Project</Typography>
                    <ResponsivePie
                        data={type_of_project}
                        colors={top_colors}
                        theme={{
                            axis: {
                                domain: {
                                    line: {
                                        stroke: colors.grey[100],
                                    },
                                },
                                legend: {
                                    text: {
                                        fill: colors.grey[100],
                                    },
                                },
                                ticks: {
                                    line: {
                                        stroke: colors.grey[100],
                                        strokeWidth: 1,
                                    },
                                    text: {
                                        fill: colors.grey[100],
                                    },
                                },
                            },
                            legends: {
                                text: {
                                    fill: colors.grey[100],
                                },
                            },
                            tooltip: {
                                container: {
                                    background: "#ffffff",
                                    color: "black",
                                    fontSize: 11,
                                },
                            }
                        }}
                        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                        activeOuterRadiusOffset={8}
                        borderColor={{
                            from: "color",
                            modifiers: [["darker", 0.2]],
                        }}
                        arcLinkLabelsSkipAngle={10}
                        arcLinkLabelsTextColor={colors.grey[100]}
                        arcLinkLabelsThickness={2}
                        arcLinkLabelsColor={{ from: "color" }}
                        enableArcLabels={false}
                        arcLabelsRadiusOffset={0.4}
                        arcLabelsSkipAngle={7}
                        arcLabelsTextColor={{
                            from: "color",
                            modifiers: [["darker", 2]],
                        }}
                        defs={[
                            {
                                id: "dots",
                                type: "patternDots",
                                background: "inherit",
                                color: "rgba(255, 255, 255, 0.3)",
                                size: 4,
                                padding: 1,
                                stagger: true,
                            },
                            {
                                id: "lines",
                                type: "patternLines",
                                background: "inherit",
                                color: "rgba(255, 255, 255, 0.3)",
                                rotation: -45,
                                lineWidth: 6,
                                spacing: 10,
                            },
                        ]}
                        legends={[
                            {
                                anchor: "bottom",
                                direction: "row",
                                justify: false,
                                translateX: 0,
                                translateY: 56,
                                itemsSpacing: 0,
                                itemWidth: 100,
                                itemHeight: 18,
                                itemTextColor: "#999",
                                itemDirection: "left-to-right",
                                itemOpacity: 1,
                                symbolSize: 18,
                                symbolShape: "circle",
                                effects: [
                                    {
                                        on: "hover",
                                        style: {
                                            itemTextColor: colors.grey[100],
                                        },
                                    },
                                ],
                            },
                        ]}

                    /></Box>
            </Box>
        </Box>



    );
};

export default PieChart;